module.exports = __webpack_public_path__ + "static/fourPetals-e2f9e82414f39c2d7ec02e33986c5bda.jpg";